import { useContext, useEffect, useState } from "react";
import { flushSync } from "react-dom";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _ipt_ from "@Elementos/Input";
import * as _btn_ from "@Elementos/Boton";
import * as _anim_ from "@Elementos/Animaciones";
import * as _tabla_ from "@Elementos/Tabla";
import * as _form_ from "@Elementos/Formulario";
import * as _opt_ from "@Elementos/Opciones";
import * as _div_ from "@Elementos/Div";
import * as _txta_ from "@Elementos/TextArea";
import * as _lul_ from "@Utilitarios/Listados/ListaUL";
import * as _preconf_ from "@Utilitarios/PreConfirmacion/PreConfirmacion";
import * as _posconf_ from "@Utilitarios/PostConfirmacion/PostConfirmacion";
import * as _procAcc_ from "@Utilitarios/ProcesandoAccion/ProcesandoAccion";
import Cards from "@Elementos/Composicion/Cards/Cards";
import Filtros from "@Composicion/Filtros/Filtros";
import MPedidoDetalle from "@Pedidos/Modales/MPedidoDetalle";
import MPedidoEliminar from "@Pedidos/Modales/MPedidoEliminar";

import img_borrar from "@Iconos/borrar.png";

import ModalInformacion from "@ModalInformacion/ModalInformacion";
import * as _testing_ from "@Funciones/testing";
import "./RegistroVentaTienda.css";

function RegistroVentaTienda() {
  const origenComponente = "RegistroVentaTienda";
  const { ecv_u, cv_u, usuarioSesion, esComputadora, rolUsuarioSesion } = useContext(Contexto);
  const [recargaComponente, erecargaComponente] = useState(false);
  const [v_c, ev_c] = useState({
    //MODAL
    modal_titulo: "",
    modal_mostrar: false,
    modal_mensaje: "",
    modal_estilos: {},
    //PRE-CONFIRMAR
    preConfirmar_mostrar: false,
    preConfirmar_funcion: () => {},
    preConfirmar_funcion_parametros: {},
    //PROCESANDO ACCION
    procesandoAccion_mostrar: false,
    //POST-CONFIRMAR
    postConfirmar_mostrar: false,
    postConfirmar_funcion: () => {},
    postConfirmar_function_parametros: {},
    //ERRORES
    errores_mostrar: false,
    errores_lista: [],
  });

  const [v_u, ev_u] = useState({
    //TABLA
    do_datosTabla: {},
    do_filtros: [
      {
        tipo: "input",
        visible: true,
        campofiltro: "Recepcionante",
        operador: "contains",
        tipoDato: "str",
      },
      {
        tipo: "input",
        visible: true,
        campofiltro: "Nro. Pedido",
        operador: "==",
        tipoDato: "int",
      },
    ],
    do_filtrosActualizados: {},
    da_grid: [],
    da_headgrid: [],
    d_multiselecion: false,
    do_seleccionados: {},

    //DATOS USUARIO
    d_deudaTotal: 0,
    da_pedidos: [],
    d_actualizarTabla: false,
    d_fechaDeVenta: _f_.fechaActual({ formato: "yyyy-mm-dd" }),
    //ESTADO PROCESAOR API
    i_procesandoApi: false,
    i_primeraCarga: true,
  });

  useEffect(() => {
    const listaPedidosAPI = _api_.f_listarPedidos({
      parametros: {
        codUsuario: "-1",
        fecha_filtro: v_u.d_fechaDeVenta,
        orden: 1,
        fecha: 3,
      },
      timeout: 5000,
      origen: origenComponente,
    });
    listaPedidosAPI.respuesta.then((dPC) => {
      _f_.asignar(ecv_u, dPC, true, origenComponente);
      console.log(dPC.contenido);
      if (!dPC.error) {
        dPC.contenido?.Pedidos?.map((elemento, idx) => {
          elemento["funcionEvento"] = {
            modo: "MODAL",
            componente: "MPedidoDetalle",
            titulo: "Detalle del Pedido",
            tipo: "onClick",
            endpoint: "actualizarRemates",
            timeout: 5000,
            estilos: {
              anchoMI: "90%",
              altoMI: "90%",
            },
          };
        });
        _f_.asignar(ev_u, {
          d_deudaTotal: dPC.contenido.Deuda,
          da_pedidos: dPC.contenido.Pedidos,
        });
      }
    });
  }, [v_u.d_fechaDeVenta, recargaComponente]);

  useEffect(() => {
    // console.log("dist:", v_u.d_codigoDistribuidor);
    // console.log("ayud:", v_u.d_codigoAyudante);
    // console.log("selec:", v_u.d_codigoUsuarioSeleccionado);
  }, [v_u.d_codigoDistribuidor, v_u.d_codigoAyudante, v_u.d_codigoUsuarioSeleccionado]);

  return (
    <div className={"RegistroVentaTiendaCSS-contenedor"}>
      {v_c.modal_mostrar && (
        <ModalInformacion
          titulo={v_c.modal_titulo}
          fCerrar={() => {
            _f_.asignar(ev_c, { modal_mostrar: false });
          }}>
          {v_c.preConfirmar_mostrar && (
            <_preconf_.PreConfirmacion
              texto={`¿Desea descargar el Reporte de Venta en Tienda del ${_f_.formatearFecha({ valor: v_u.d_fechaDeVenta, formato: "dd/mm/yyyy" })}?`}
              fBotonCancelar={() => {
                _f_.asignar(ev_c, {
                  modal_mostrar: false,
                  preConfirmar_mostrar: false,
                  procesandoAccion_mostrar: false,
                  postConfirmar_mostrar: false,
                  modal_titulo: "",
                });
              }}
              fBotonAceptar={() => {
                _f_.asignar(ev_c, {
                  preConfirmar_mostrar: false,
                  procesandoAccion_mostrar: true,
                  modal_titulo: "⏳Obteniendo Excel",
                });
                const reporteVentaTiendaAPI = _api_.f_reportePagosVT({
                  parametros: { fecha: v_u.d_fechaDeVenta },
                  timeout: 5000,
                  origen: origenComponente,
                });
                reporteVentaTiendaAPI.respuesta.then((dPC) => {
                  _f_.asignar(ecv_u, dPC, true, origenComponente);
                  console.log(dPC);
                  if (!dPC.error) {
                    _f_.descargarExcelBase64({base64:dPC.contenido.reporte,nombreArchivo:`Reporte_ventan_tienda_${_f_.formatearFecha({ valor: v_u.d_fechaDeVenta, formato: "dd/mm/yyyy" })}_${_f_.horaActual({formato:"hh_mm_ss"})}`})
                    _f_.asignar(ev_c, {
                      procesandoAccion_mostrar: false,
                      postConfirmar_mostrar: true,
                      modal_titulo: "Excel Descargado",
                    });
                  }
                });
              }}
            />
          )}
          {v_c.procesandoAccion_mostrar && <_procAcc_.ProcesandoAccion />}
          {v_c.postConfirmar_mostrar && (
            <_posconf_.PostConfirmacion
              fBotonDeAcuerdo={() => {
                _f_.asignar(ev_c, {
                  modal_mostrar: false,
                  preConfirmar_mostrar: false,
                  procesandoAccion_mostrar: false,
                  postConfirmar_mostrar: false,
                  modal_titulo: "",
                });
              }}
            />
          )}
        </ModalInformacion>
      )}
      <div className="titulo-componente">{"Registro de Ventas"}</div>
      <div className={"RegistroVentaTiendaCSS-cabecera"}>
        <_div_.Div3
          cabecera={`Caja Total (${_f_.formatearFecha({ valor: v_u.d_fechaDeVenta, formato: "dd/mm/yyyy" })}) :`}
          estilos={{ fuenteDiv2: "1.3rem" }}
          texto={`${_f_.formatearValor({ valor: v_u.d_deudaTotal, tipo: "moneda", moneda: "PEN", precision: "2" })}`}
        />
        {["SADM01"].includes(rolUsuarioSesion) && (
          <_ipt_.Input4
            tipo="date"
            texto="Fecha de Ventas"
            clave={["codUsuario"]}
            valor={["Nombre", "ApellidoPaterno", "ApellidoMaterno"]}
            defaultValue={v_u.d_fechaDeVenta}
            opciones={v_u.da_distribuidores || []}
            name={"wefwfwefwef"}
            estilos={{ flexGrow: 0, width: "100%" }}
            seleccionado={v_u.d_codigoDistribuidor}
            onBlur={(evento) => {
              console.log("fecha");

              _f_.asignar(ev_u, {
                d_fechaDeVenta: _f_.formatearFecha({ valor: evento.target.value, formato: "yyyy-mm-dd" }),
              });
            }}
          />
        )}
        <_btn_.Boton
          texto={`Generar Reporte`}
          tipo="btn-2"
          estilos={{
            anchoB2: "10rem",
            color: "var(--color_verde_1)",

            fuente: "1rem",
          }}
          onClick={() => {
            _f_.asignar(ev_c, {
              modal_mostrar: true,
              modal_titulo: "Descargar Reporte Excel",
              preConfirmar_mostrar: true,
            });
          }}
        />
      </div>
      <Filtros
        filtros={v_u.do_filtros}
        funcionObtenerValores={(valores) => {
          console.log(valores);
          _f_.asignar(ev_u, { do_filtrosActualizados: valores });
        }}
      />
      <div className={"RegistroVentaTiendaCSS-cuerpo"}>
        {Array.from({ length: 1 }).map((pedido, idx_pedido) => {
          const filaCabecera = {
            columnas: 2,
            alineacion: "between",
            items: [
              {
                label: "Usuario Solicitante",
                campo: "nombreUsuarioSolicitante", // Ruta directa o anidada (ej: "datos.nombre")
                mostrarLabel: false,
                claseDato: "CardsCSS-valor-principal",
              },
              {
                label: "Nro. Pedido",
                campo: "codPedido",
                mostrarLabel: false,
                claseDato: "CardsCSS-badge",
                // O si quieres formatearlo:
                valor: (val) => `Nro. ${String(val).padStart(8, "0")}`,
              },
            ],
          };

          const filaRecepcion = {
            columnas: 1,
            items: [{ label: "Recepcionante", campo: "nombreUsuarioRecepcionante" }],
          };

          const filaDespacho = {
            columnas: 1,
            items: [{ label: "Despachador", campo: "nombreUsuarioEntrega" }],
          };

          const filaTotales = {
            columnas: 2,
            items: [
              {
                label: "F. Entrega",
                campo: "fechaEntregadaReal",
                valor: (fechaCruda) =>
                  _f_.formatearFecha({
                    valor: fechaCruda,
                    incluirHora: true,
                    formato: "dd/mm/yyyy hh:MM:ss a",
                    formatoHora: 12,
                  }),
              },
              {
                label: "Total Entregado",
                campo: "totalEntrega",
                valor: (monto) =>
                  _f_.formatearValor({
                    valor: monto,
                    tipo: "moneda",
                    moneda: "PEN",
                    precision: "2",
                  }),
                claseDato: "CardsCSS-text-success",
              },
            ],
          };

          return (
            <Cards
              origenComponente={origenComponente}
              key={idx_pedido}
              elementos={v_u.da_pedidos}
              filtros={v_u.do_filtrosActualizados}
              contextoReglas={{
                rolUsuarioSesion: rolUsuarioSesion,
              }}
              filasDatos={[filaCabecera, filaRecepcion, filaDespacho, filaTotales]}
              fNotificarActualizacionDeTabla={(actualizar) => {
                if (actualizar) {
                  erecargaComponente((prev) => !prev);
                }
              }}
              mapaEstadosClases={{
                deshabilitado: "CardsCSS-estado-deshabilitado",
                aprobado: "CardsCSS-estado-aprobado",
              }}
              mapaDeComponentes={{
                MPedidoDetalle,
                MPedidoEliminar,
              }}
              // reglasDeEstados={[
              //   {
              //     tipo: "deshabilitado",
              //     reglas: [
              //       {
              //         campo: "entregado",
              //         criterio: "N",
              //         operador: "==",
              //         conector: "and",
              //       },
              //     ],
              //   },
              //   {
              //     tipo: "aprobado",
              //     reglas: [
              //       {
              //         campo: "entregado",
              //         criterio: "S",
              //         operador: "==",
              //         conector: "and",
              //       },
              //     ],
              //   },
              // ]}
            />
          );
        })}
      </div>
    </div>
  );
}
export default RegistroVentaTienda;
